import { AILessonPlanPayload } from '../service/aiLessonPlanService'

/**
 * Valida se o payload está no formato correto esperado pela API
 */
export function validatePayload(payload: AILessonPlanPayload): {
  isValid: boolean
  errors: string[]
} {
  const errors: string[] = []

  // Validar campos obrigatórios de nível superior
  if (!payload.number_meetings || payload.number_meetings <= 0) {
    errors.push('number_meetings deve ser maior que 0')
  }

  if (!payload.date_start_at || !/^\d{4}-\d{2}-\d{2}$/.test(payload.date_start_at)) {
    errors.push('date_start_at deve estar no formato YYYY-MM-DD')
  }

  if (!payload.name || payload.name.trim().length === 0) {
    errors.push('name é obrigatório')
  }

  if (!payload.purpose || payload.purpose.trim().length === 0) {
    errors.push('purpose é obrigatório')
  }

  if (!payload.synopsis || payload.synopsis.trim().length === 0) {
    errors.push('synopsis é obrigatório')
  }

  // Validar arrays
  if (!Array.isArray(payload.objectives) || payload.objectives.length === 0) {
    errors.push('objectives deve ser um array com pelo menos um item')
  }

  if (!Array.isArray(payload.stages) || payload.stages.length === 0) {
    errors.push('stages deve ser um array com pelo menos um item')
  }

  // Validar project_items
  if (!payload.project_items) {
    errors.push('project_items é obrigatório')
  } else {
    if (!Array.isArray(payload.project_items.contents)) {
      errors.push('project_items.contents deve ser um array')
    }

    if (!Array.isArray(payload.project_items.specific_skills)) {
      errors.push('project_items.specific_skills deve ser um array')
    }

    // Validar estrutura de cada content
    payload.project_items.contents.forEach((content, index) => {
      if (!content.id) errors.push(`content[${index}].id é obrigatório`)
      if (!content.name) errors.push(`content[${index}].name é obrigatório`)
      if (!content.lv1_name) errors.push(`content[${index}].lv1_name é obrigatório`)
      if (!content.breadcrumb) errors.push(`content[${index}].breadcrumb é obrigatório`)
      if (content.curriculum_kind !== 'content') {
        errors.push(`content[${index}].curriculum_kind deve ser "content"`)
      }
    })

    // Validar estrutura de cada skill
    payload.project_items.specific_skills.forEach((skill, index) => {
      if (!skill.id) errors.push(`specific_skill[${index}].id é obrigatório`)
      if (!skill.name) errors.push(`specific_skill[${index}].name é obrigatório`)
      if (!skill.lv1_name) errors.push(`specific_skill[${index}].lv1_name é obrigatório`)
      if (!skill.breadcrumb) errors.push(`specific_skill[${index}].breadcrumb é obrigatório`)
      if (skill.curriculum_kind !== 'skill') {
        errors.push(`specific_skill[${index}].curriculum_kind deve ser "skill"`)
      }
    })
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}

